<template>
    <div class="tw-relative tw-flex tw-flex-col tw-items-center tw-scale-95 tw-group">
        <!-- Star Ribbon Above Badge -->
        <div v-if="badge.stars"
            class="tw-absolute tw-z-10 tw-top-[-10px] tw-scale-50 tw-px-2 tw-py-1 tw-bg-black/80 tw-text-yellow-400 tw-rounded-full tw-flex tw-items-center tw-gap-1">
            <icon icon="mdi:star" v-for="n in badge.stars" :key="n" class="tw-text-sm" />
        </div>

        <!-- Badge Icon -->
        <div class="tw-relative tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-rounded-md tw-shadow-md tw-border-2 tw-border-white"
            :class="badge.bgColor">
            <icon :icon="badge.icon" class="tw-text-xl" :class="badge.iconColor" />
        </div>

        <div class="tw-translate-y-1/2 tw-opacity-0 tw-whitespace-nowrap tw-text-sm tw-py-0.5 group-hover:tw-opacity-100 tw-duration-200  tw-absolute -tw-bottom-2 tw-px-4 tw-font-semibold tw-bg-white tw-rounded group-hover:tw-translate-y-full tw-shadow-lg tw-border tw-border-solid tw-border-gray-200">
            {{ $t(badge.label) }}
        </div>
    </div>
</template>

<script setup>
const badges = [
  { icon: "mdi:medal-outline", label: "badges.level-1", bgColor: "tw-bg-gray-400", iconColor: "tw-text-white", stars: 0 },
  { icon: "mdi:medal", label: "badges.level-2", number: "100", bgColor: "tw-bg-blue-500", iconColor: "tw-text-white", stars: 1 },
  { icon: "mdi:medal", label: "badges.level-3", number: "300", bgColor: "tw-bg-orange-500", iconColor: "tw-text-white", stars: 2 },
  { icon: "mdi:crown", label: "badges.level-4", number: "500", bgColor: "tw-bg-yellow-500", iconColor: "tw-text-white", stars: 3 },
];

const badge = badges[0];
</script>

<style></style>